"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Div = exports.SpacingContainer = exports.borderRule = exports.hideAt = exports.mediaPadding = exports.padding = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var layout_1 = require("../util/layout");
var padding = function (rule, size) {
    return "".concat(rule, ": ").concat((0, layout_1.space)(size), ";");
};
exports.padding = padding;
var mediaPadding = function (bp, rule, size) { return "\n  @media (max-width: ".concat((0, layout_1.breakPoint)(bp), "px) {\n    ").concat((0, exports.padding)(rule, size), "\n  }\n"); };
exports.mediaPadding = mediaPadding;
var hideAt = function (bp, under) { return "\n  @media (".concat(under ? 'max' : 'min', "-width: ").concat((0, layout_1.breakPoint)(bp) + (under ? 0 : 1), "px) {\n    display: none !important;\n  }\n"); };
exports.hideAt = hideAt;
var borderRule = function (b, color, direction) {
    if (direction === void 0) { direction = 'all'; }
    return "border".concat(direction === 'all' ? '' : "-".concat(direction), ": ").concat(typeof b === 'boolean' ? '1px' : "".concat(b, "px"), " solid ").concat(color, ";");
};
exports.borderRule = borderRule;
var TheSpacingContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n\n  ", "\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n\n  ", "\n", "\n\n  ", "\n"], ["\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n\n  ", "\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", "\n\n  ", "\n", "\n\n  ", "\n"])), function (_a) {
    var p = _a.p;
    return (p ? (0, exports.padding)('padding', p) : '');
}, function (_a) {
    var py = _a.py;
    return py ? (0, exports.padding)('padding-top', py) + (0, exports.padding)('padding-bottom', py) : '';
}, function (_a) {
    var pt = _a.pt;
    return (pt ? (0, exports.padding)('padding-top', pt) : '');
}, function (_a) {
    var pb = _a.pb;
    return (pb ? (0, exports.padding)('padding-bottom', pb) : '');
}, function (_a) {
    var px = _a.px;
    return px ? (0, exports.padding)('padding-left', px) + (0, exports.padding)('padding-right', px) : '';
}, function (_a) {
    var pl = _a.pl;
    return (pl ? (0, exports.padding)('padding-left', pl) : '');
}, function (_a) {
    var pr = _a.pr;
    return (pr ? (0, exports.padding)('padding-right', pr) : '');
}, function (_a) {
    var smP = _a.smP;
    return (smP ? (0, exports.mediaPadding)('sm', 'padding', smP) : '');
}, function (_a) {
    var smPy = _a.smPy;
    return smPy || smPy === 0
        ? (0, exports.mediaPadding)('sm', 'padding-top', smPy) +
            (0, exports.mediaPadding)('sm', 'padding-bottom', smPy)
        : '';
}, function (_a) {
    var smPx = _a.smPx;
    return smPx || smPx === 0
        ? (0, exports.mediaPadding)('sm', 'padding-left', smPx) +
            (0, exports.mediaPadding)('sm', 'padding-right', smPx)
        : '';
}, function (_a) {
    var m = _a.m;
    return (m ? (0, exports.padding)('margin', m) : '');
}, function (_a) {
    var my = _a.my;
    return my ? (0, exports.padding)('margin-top', my) + (0, exports.padding)('margin-bottom', my) : '';
}, function (_a) {
    var mt = _a.mt;
    return (mt ? (0, exports.padding)('margin-top', mt) : '');
}, function (_a) {
    var mb = _a.mb;
    return (mb ? (0, exports.padding)('margin-bottom', mb) : '');
}, function (_a) {
    var mx = _a.mx;
    return mx ? (0, exports.padding)('margin-left', mx) + (0, exports.padding)('margin-right', mx) : '';
}, function (_a) {
    var ml = _a.ml;
    return (ml ? (0, exports.padding)('margin-left', ml) : '');
}, function (_a) {
    var mr = _a.mr;
    return (mr ? (0, exports.padding)('margin-right', mr) : '');
}, function (_a) {
    var hideUnder = _a.hideUnder;
    return (hideUnder ? (0, exports.hideAt)(hideUnder, true) : '');
}, function (_a) {
    var hideOver = _a.hideOver;
    return (hideOver ? (0, exports.hideAt)(hideOver, false) : '');
}, function (_a) {
    var b = _a.b, theme = _a.theme;
    return (b ? (0, exports.borderRule)(b, theme.colors.border) : '');
}, function (_a) {
    var bt = _a.bt, theme = _a.theme;
    return (bt ? (0, exports.borderRule)(bt, theme.colors.border, 'top') : '');
}, function (_a) {
    var bb = _a.bb, theme = _a.theme;
    return bb ? (0, exports.borderRule)(bb, theme.colors.border, 'bottom') : '';
}, function (_a) {
    var bl = _a.bl, theme = _a.theme;
    return (bl ? (0, exports.borderRule)(bl, theme.colors.border, 'left') : '');
}, function (_a) {
    var br = _a.br, theme = _a.theme;
    return (br ? (0, exports.borderRule)(br, theme.colors.border, 'right') : '');
}, function (_a) {
    var by = _a.by, theme = _a.theme;
    return by
        ? (0, exports.borderRule)(by, theme.colors.border, 'bottom') +
            (0, exports.borderRule)(by, theme.colors.border, 'top')
        : '';
}, function (_a) {
    var bx = _a.bx, theme = _a.theme;
    return bx
        ? (0, exports.borderRule)(bx, theme.colors.border, 'left') +
            (0, exports.borderRule)(bx, theme.colors.border, 'right')
        : '';
}, function (_a) {
    var grow = _a.grow;
    return (grow ? 'flex-grow: 1;' : '');
}, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor ? "background-color: ".concat(backgroundColor, ";") : '';
}, function (_a) {
    var borderRadius = _a.borderRadius;
    return (borderRadius ? "border-radius: ".concat(borderRadius, ";") : '');
}, function (_a) {
    var width = _a.width;
    return width
        ? "\n        @media(max-width: ".concat(width + 32, "px) {\n          max-width: ").concat(width, "px;\n          width: 100%;\n        }\n\n        @media (min-width: ").concat(width + 32, "px) {\n          width: ").concat(width, "px;\n        }\n      ")
        : '';
});
exports.SpacingContainer = react_1.default.forwardRef(function (_a, ref) {
    var hideFromFullStory = _a.hideFromFullStory, className = _a.className, rest = __rest(_a, ["hideFromFullStory", "className"]);
    return (react_1.default.createElement(TheSpacingContainer, __assign({ ref: ref }, rest, { className: "".concat(hideFromFullStory ? '__fullstory_hidden ' : '').concat(className ? className : '') })));
});
exports.Div = exports.SpacingContainer;
var templateObject_1;
//# sourceMappingURL=spacing.js.map